import * as React from 'react';

const ActiveStepContext = React.createContext<string | undefined>(undefined);

export const ActiveStepProvider = ActiveStepContext.Provider;
export const useActiveStepValue = () => React.useContext(ActiveStepContext);
